import { render, staticRenderFns } from "./DatosUnidades.vue?vue&type=template&id=301a8c46&scoped=true"
import script from "./DatosUnidades.vue?vue&type=script&lang=js"
export * from "./DatosUnidades.vue?vue&type=script&lang=js"
import style0 from "./DatosUnidades.vue?vue&type=style&index=0&id=301a8c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301a8c46",
  null
  
)

export default component.exports